import { ca } from '@cian/analytics';
import { TPage, TPageExtra } from '../../../types/analytics';

export function trackAntifraudPopupShow(page: TPage, extra: TPageExtra) {
  ca('eventSite', {
    action: 'Show_sopr',
    category: 'CallBack_antifraud_popup',
    label: '/sale/flat/object_type=2/from_developer=1/',
    name: 'oldevent',
    useLastProducts: true,
    page: {
      ...page,
      extra: {
        ...extra,
      },
    },
  });
}

export function trackAntifraudPopupConfirm(page: TPage, extra: TPageExtra) {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'CallBack_antifraud_popup',
    label: 'Confirm',
    name: 'oldevent',
    useLastProducts: true,
    page: {
      ...page,
      extra: {
        ...extra,
      },
    },
  });
}

export function trackAntifraudPopupChangePhone(page: TPage, extra: TPageExtra) {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'CallBack_antifraud_popup',
    label: 'Change_phone',
    name: 'oldevent',
    useLastProducts: true,
    page: {
      ...page,
      extra: {
        ...extra,
      },
    },
  });
}

export function trackAntifraudPopupResendCode(page: TPage, extra: TPageExtra) {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'CallBack_antifraud_popup',
    label: 'Change_Resend_codephone',
    name: 'oldevent',
    useLastProducts: true,
    page: {
      ...page,
      extra: {
        ...extra,
      },
    },
  });
}
